import React from 'react';

const OrderBook = ({ bids, asks, spread = 0.5 }) => {
    // Mock data
    const mockBids = bids || Array.from({ length: 6 }, (_, i) => ({
        price: 0.45 - i * 0.01,
        size: Math.floor(Math.random() * 5000) + 1000,
        total: Math.floor(Math.random() * 10000)
    }));

    const mockAsks = asks || Array.from({ length: 6 }, (_, i) => ({
        price: 0.46 + i * 0.01,
        size: Math.floor(Math.random() * 5000) + 1000,
        total: Math.floor(Math.random() * 10000)
    }));

    const Row = ({ item, type }) => (
        <div className="grid grid-cols-3 text-xs py-1 hover:bg-white/5 cursor-pointer transition-colors">
            <div className={`text-left ${type === 'bid' ? 'text-emerald-400' : 'text-red-400'}`}>
                {item.price.toFixed(2)}¢
            </div>
            <div className="text-right text-gray-300">
                {item.size.toLocaleString()}
            </div>
            <div className="text-right text-gray-400">
                ${item.total.toLocaleString()}
            </div>
        </div>
    );

    return (
        <div className="bg-white/[0.02] border border-white/10 rounded-xl p-4 h-full flex flex-col">
            <div className="flex justify-between items-center mb-4 border-b border-white/5 pb-2">
                <h3 className="text-sm font-bold text-muted-foreground">Order Book</h3>
                <div className="flex gap-2 text-xs">
                    <span className="text-muted-foreground">Spread:</span>
                    <span className="text-white">{spread}%</span>
                </div>
            </div>

            <div className="grid grid-cols-3 text-xs text-muted-foreground mb-2 px-1">
                <div className="text-left">Price</div>
                <div className="text-right">Size</div>
                <div className="text-right">Total</div>
            </div>

            <div className="flex-1 overflow-y-auto space-y-1 pr-1 custom-scrollbar">
                {/* Asks (Sells) - usually roughly sorted high to low visually effectively, but standard is Low to High for Asks going UP from mid price */}
                <div className="flex flex-col-reverse">
                    {mockAsks.map((ask, i) => <Row key={`ask-${i}`} item={ask} type="ask" />)}
                </div>

                <div className="py-2 flex items-center justify-center gap-2 border-y border-white/5 my-1">
                    <span className="text-lg font-bold text-emerald-400">46.5¢</span>
                    <span className="text-xs text-muted-foreground">Market Price</span>
                </div>

                {/* Bids (Buys) - High to Low */}
                <div className="flex flex-col">
                    {mockBids.map((bid, i) => <Row key={`bid-${i}`} item={bid} type="bid" />)}
                </div>
            </div>
        </div>
    );
};

export default OrderBook;
